import { Button } from '@factorialco/deprecated-design-system'
import {
  EmployeeGroupRootPageDocument,
  EmployeeGroupUpdateDocument,
  SettingsEmployeeGroupFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  employeeGroup: SettingsEmployeeGroupFragment
  onClose: () => void
}

const MakeMainModal = ({ onClose, employeeGroup }: Props) => {
  const [EmployeeGroupUpdate] = useMutation(EmployeeGroupUpdateDocument, {
    extractorFn: (data) => data.employeesMutations.updateEmployeesEmployeeGroup,
  })

  const onSubmit = async (closePortal: ClosePortalFn) => {
    const result = await EmployeeGroupUpdate({
      variables: {
        id: employeeGroup.id,
        main: true,
      },
      refetchQueries: [EmployeeGroupRootPageDocument],
    })
    const handler = handleResult(result, () => null)

    if (handler.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
      closePortal()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_saving'),
      })
    }
  }

  return (
    <Modal
      title={i18n.t('settings.legal_entities.legal_entity.employee_group.main.title', {
        name: employeeGroup.name,
      })}
      illustration="group"
      description={i18n.t('settings.legal_entities.legal_entity.employee_group.main.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button submit>
          {i18n.t('settings.legal_entities.legal_entity.employee_group.main.submit')}
        </Button>
      }
    />
  )
}

export default observer(MakeMainModal)
